import BookFreeClassBtn from '@components/common/book-free-class-btn'
import StudentProjectCard from '@components/common/project-card-v2'
import useDetectCountry from '@hooks/useDetectCountry'
import { HOMEPAGE_STUDENT_PROJECTS } from '@lib/data/home-student-projects'
import { Trans } from '@lingui/macro'
import MsgTrans from '@components/common/i18n/message-trans'
import { ProjectType } from '@lib/data/student-projects'

const IMAGE_PATH = '/images/home/student-projects/v1/'

type Props = {
  localeCountryCode?: string
  customProjects?: ProjectType[]
  title?: string
  description?: string
  scaleOnHover?: boolean
  hideCta?: boolean
}

/** i18n support added */
const StudentProjects = ({
  localeCountryCode,
  customProjects,
  title,
  description,
  scaleOnHover = true,
  hideCta = false,
}: Props) => {
  const { countryCode } = useDetectCountry()
  const projects =
    customProjects ??
    (HOMEPAGE_STUDENT_PROJECTS[localeCountryCode || countryCode] ||
      HOMEPAGE_STUDENT_PROJECTS['default'])

  return (
    <div className="bg-orange-100">
      <div className="container mx-auto text-grey-900 relative px-5 py-12 lg:py-16">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-4xl leading-tight text-center font-600">
            {title ? (
              <MsgTrans msg={title} />
            ) : (
              <Trans id="homepage.studentProjects.heading">
                See amazing projects{' '}
                <span className="yellow-underline">
                  created by our students
                </span>
              </Trans>
            )}
          </h2>
          {description && (
            <p className="text-lg text-grey mt-2">{description}</p>
          )}
        </div>
        <div className="relative grid grid-cols-1 my-4 lg:justify-center gap-y-5 md:gap-6 lg:gap-8 md:grid-cols-2 lg:grid-cols-3">
          {projects.map((project) => (
            <StudentProjectCard
              key={project.projectLink}
              imagePath={IMAGE_PATH}
              scaleOnHover={scaleOnHover}
              {...project}
            />
          ))}
        </div>
        {!hideCta && (
          <div className="flex flex-col justify-center mt-10 gap-y-4 lg:mx-0 lg:flex-row lg:gap-x-4 pb-2 lg:pb-5">
            <BookFreeClassBtn size="xl" />
          </div>
        )}
      </div>
    </div>
  )
}

export default StudentProjects
